<div class="dialpad" *ngIf="this.isLeadUserInterface != undefined">
  <div class="phone-number-input-container">
    <input type="text" [(ngModel)]="phoneNumber" id="dialPadNumber" (keypress)="validateInput($event)" maxlength="10"
      placeholder="Enter phone number" class="phone-number-input" [disabled]="callState !== 'none' || waitingOnDisposition"
      [title]="waitingOnDisposition ? 'Cannot dial while waiting on a disposition' : ''"
      [attr.autocomplete]="'dial-phone'" (paste)="onPaste($event)">
  </div>
  <div *ngFor="let row of keypadRows">
    <button *ngFor="let key of row" (click)="appendToPhoneNumber(key.number)" class="dialpad-button">
      <span class="button-content">
        <span class="number">{{key.number}}</span>
        <span *ngIf="key.letters" class="letters">{{key.letters}}</span>
        <span *ngIf="!key.letters" class="letters">&nbsp;</span>
      </span>
    </button>
  </div>
  <div>
    <button (click)="handleDial()" [disabled]="(!isValidNumber() && callState === 'none') || waitingOnDisposition" [ngClass]="{
      'dial-button': true, 
      'valid-number': isValidNumber(), 
      'call-active': callState !== 'none', 
      'loading-state': callState === 'loading'
    }">
      <ng-container *ngIf="callState === 'none'">
        <i class="bi bi-telephone" style="font-size: 1.5rem;"
          [title]="waitingOnDisposition ? 'Cannot dial while waiting on a disposition' : ''"
          [class]=" callState === 'none' ? 'fa-phone-slash' : 'fa-phone-alt'"></i>
      </ng-container>
      <ng-container *ngIf="callState === 'loading'">
        <output class="spinner-border spinner-border-sm" aria-live="polite">
          <span class="visually-hidden">Loading...</span>
        </output>
      </ng-container>
      <ng-container *ngIf="callState === 'connected'">
        <i class="bi bi-telephone-x" style="font-size: 1.5rem;"></i>
      </ng-container>
    </button>
    <button *ngIf="customerParticipantId && agentParticipantId && callState === 'connected'" class="svg-button"
      (click)="onConsultTransfer()">
      <i class="bi bi-person-plus" style="font-size: 1.5rem;"></i>
    </button>
  </div>
  <div class="checkbox-container">
    <span><b>Local Touch?</b></span>
    <input type="checkbox" id="localTouchCheckbox" [checked]="localTouch" (change)="togglelocalTouch()"
      class="localTouch-checkbox" />
  </div>
</div>
<div class="version-text">
  Version: {{ version }}
</div>
